// extracted by mini-css-extract-plugin
export var currencyInput = "_jt-1";
export var currencySymbol = "_jt-0";